import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import styled from 'styled-components';
import PT from 'prop-types';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

class ListItem extends PureComponent {
  render() {
    const {
      children,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('list-item')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement("li", _extends({}, getDataTaktAttributes(), rest), children));
  }
}
_defineProperty(ListItem, "propTypes", {
  children: PT.node.isRequired
});
const StyledListItem = /*#__PURE__*/styled(ListItem).withConfig({
  componentId: "sc-storm-ui-30060407__sc-1r8eex-0"
})([""]);
StyledListItem.displayName = 'ListItem';

export { StyledListItem as S };
//# sourceMappingURL=ListItem-GmtXFL7V.js.map
